import React, { useState } from "react";
import { DisplayMsg } from "../../services/toastService";
import { setUrl } from "../../handlers";

const Password = (props) => {
  const [PasswordInfo, setPasswordInfo] = useState({
    error: false,
    passwordErr: false,
    rePasswordErr: false,
    passMsg: "",
    barColor: "",
    password: "",
    column: "",
    rePassword: "",
    errorMessage: "Required",
    bar: false,
    rePassMsg: "",
  });

  const SetPasswordData = (e) => {
    const ValidPassword = new RegExp(
      "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$"
    );
    const validPasswordNew = new RegExp(
      "^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$"
    );
    const curVal = e.target.value;
    switch (e.target.name) {
      case "password":
        setPasswordInfo((passwordData) => ({
          ...passwordData,
          bar: true,
          password: curVal,
          passMsg: "",
        }));

        if (curVal.length < 1) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            error: true,
            barColor: "red",
            column: "col-1",
            errorMessage: "Too short Password! not acceptable",
          }));
        } else if (
          curVal.length > 0 &&
          curVal.length < 4 &&
          !ValidPassword.test(curVal)
        ) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            error: true,
            barColor: "red",
            column: "col-3",
            errorMessage: "Too short Password! not acceptable",
          }));
        } else if (curVal.length < 6 && !ValidPassword.test(curVal)) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            error: true,
            barColor: "orange",
            column: "col-6",
            errorMessage: "Weak Password! not acceptable",
          }));
        } else if (ValidPassword.test(curVal)) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            error: true,
            barColor: "green",
            column: "col-12",
            errorMessage: "Strong! Recommended Password",
          }));
        } else if (curVal.length > 5 && validPasswordNew.test(curVal)) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            error: true,
            barColor: "blue",
            column: "col-9",
            errorMessage: "Looks Good!Strong Password is Recommended",
          }));
        }
        break;

      case "rePassword":
        setPasswordInfo((passwordData) => ({
          ...passwordData,
          rePassword: curVal,
        }));
        if (curVal.length > 1) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            rePasswordErr: false,
            rePassMsg: "",
            rePassword: curVal,
          }));
        }
        break;
      default:
        break;
    }
  };

  const ChangePassword = async () => {
    try {
      if (PasswordInfo.password === "" || PasswordInfo.rePassword === "") {
        DisplayMsg("2", "Passwords is required");
        return;
      }
      if (PasswordInfo.password !== PasswordInfo.rePassword) {
        DisplayMsg("2", "Passwords don't match, retry after changing.");
        return;
      }
      document.getElementById("loader").style.display = "block";
      const formdata = new FormData();
      formdata.append("USER", sessionStorage.USER);
      formdata.append("USER_SEQ_NUM", sessionStorage.SEQ_NUM);
      formdata.append("NEWPASSWORD", PasswordInfo.password);

      const result = await fetch(
        setUrl("CHANGEPASSWORD", "SAVECHANGEPASSWORD"),
        {
          method: "POST",
          body: formdata,
        }
      );
      const response = await result.json();
      if (response.status) {
        DisplayMsg("1", response.Message);
      } else {
        DisplayMsg("2", response.Message);
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const PasswordPopup = () => {
    props.parentCallback(false);
  };

  const PasswordMatch = (e) => {
    const curVal = e.target.value;
    const curName = e.target.name;
    switch (curName) {
      case "password":
        if (curVal.length < 1) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            passMsg: "Required",
          }));
        }
        break;
      case "rePassword":
        if (curVal.length < 1) {
          setPasswordInfo((passwordData) => ({
            ...passwordData,
            rePasswordErr: true,
            rePassMsg: "Required",
          }));
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />
      <div className="overlay">
        <div className="popup change-password">
          <div className="popup__header">
            <h3>Change Password</h3>
            <span
              className="close"
              role="button"
              onClick={() => PasswordPopup(false)}
            >
              ×
            </span>
          </div>

          <div className="content">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <h3>Password must contain the following:</h3>
                  <ul>
                    <li>A lowercase letter</li>
                    <li>A capital (uppercase) letter</li>
                    <li>A number and a special character</li>
                    <li>Use 6 to 50 characters</li>
                  </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="field-wrapper">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        New Password
                      </label>
                      <input
                        className="field-input"
                        type="password"
                        name="password"
                        onChange={(e) => SetPasswordData(e)}
                        onFocus={(e) => PasswordMatch(e)}
                        value={PasswordInfo.password}
                      />
                    </div>
                    <div
                      className={`${
                        PasswordInfo.passMsg.length > 0 ? "d-block" : "d-none"
                      } text-xs text-red-500`}
                    >
                      {PasswordInfo.passMsg}
                    </div>
                    <div
                      className={`${
                        PasswordInfo.error ? "d-block" : "d-none"
                      } text-xs `}
                      style={{ color: `${PasswordInfo.barColor}` }}
                    >
                      {PasswordInfo.errorMessage}
                    </div>
                    <div
                      className={`${
                        PasswordInfo.bar == true ? "row d-block" : "d-none"
                      } ml-0 bg-gray-100 border-1 border-round-3xl border-transparent d-block row w-6 `}
                    >
                      <div
                        className={`${PasswordInfo.column} bg-${PasswordInfo.barColor}-500 border-round-2xl p-1 `}
                       />
                    </div>
                    <span
                      id="warntxtpasswordStrength"
                      className="requiredFld"
                     />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="field-wrapper">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        Retype Password
                      </label>
                      <input
                        className="field-input"
                        type="password"
                        name="rePassword"
                        onChange={(e) => SetPasswordData(e)}
                        onFocus={(e) => PasswordMatch(e)}
                        value={PasswordInfo.rePassword}
                      />
                    </div>
                    <span
                      className={`${
                        PasswordInfo.rePasswordErr ? "d-block" : "d-none"
                      } text-xs text-red-500`}
                    >
                      {PasswordInfo.rePassMsg}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row text-center">
                <div className="col-md-12 col-sm-12">
                  <label>&nbsp;</label>
                  <input
                    type="button"
                    className="btnLinkGreen"
                    value="Update"
                    onClick={() => ChangePassword()}
                  />
                  <input
                    type="button"
                    className="btnCancel"
                    value="Cancel"
                    onClick={() => PasswordPopup()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Password;
